import styled from 'styled-components';

import colors from '@theme/colors';

export const TermsText = styled.p`
  color: ${({ dark }) => (dark ? colors['beige'] : colors['charcoal'])};
  font-size: 14px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  margin: 1.5rem auto 0;
  text-align: center;
  max-width: 260px;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
